.nav {
  min-width: 0;
}

.list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--font-size-sm);
}

.item {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  min-width: 0;
}

.link,
.link a {
  color: var(--color-text-muted);
  text-decoration: none;
}

.link:hover,
.link a:hover {
  color: var(--color-link);
  text-decoration: underline;
}

.current {
  color: var(--color-text);
  font-weight: var(--font-weight-medium);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 24rem;
}

.separator {
  flex-shrink: 0;
  color: var(--color-text-subtle);
}
